export const navIcons = {
    profile: 'person',
    dashboard: 'house',
    actionPoints: 'list',
    modules: 'grid_view',
    myOrganization: 'business',
    teams: 'group',
    admin: 'key',
    manual: 'article',
    logout: 'login',
    notifications: 'notifications'
};
